import React from "react"
import styled from "styled-components"
import { SectionWrapper } from "../../components/common/wrappers/Wrappers"
import { breakpoint, color, transition, opacity } from "../../configs/utilities"
import { SectionTitle } from "../../components/common/typography/Typography"
import iconAngieslist from "../../assets/mover/iconAngieslist.svg"
import iconBbb from "../../assets/mover/iconBbb.svg"
import iconFacebook from "../../assets/mover/iconFacebook.svg"
import iconGoogle from "../../assets/mover/iconGoogle.svg"
import iconYellowPages from "../../assets/mover/iconYellowPages.svg"
import iconYelp from "../../assets/mover/iconYelp.svg"
import Map from "../../components/common/map/Map"
import dot from "../../assets/config/dot.svg"
import HorizontalLine from "../../components/common/typography/HorizontalLine"
const ContactSection = ({
  facebook_url,
  bbb_url,
  angieslist_url,
  google_page_url,
  yellow_pages_url,
  yelp_url,
  address,
  city,
  state,
  phone,
  website,
  lat,
  lon,
}) => {
  const socials = [
    {
      url: facebook_url,
      icon: iconFacebook,
    },
    {
      url: bbb_url,
      icon: iconBbb,
    },
    {
      url: angieslist_url,
      icon: iconAngieslist,
    },
    {
      url: google_page_url,
      icon: iconGoogle,
    },
    {
      url: yellow_pages_url,
      icon: iconYellowPages,
    },
    {
      url: yelp_url,
      icon: iconYelp,
    },
  ]

  return (
    <Wrapper>
      <HorizontalLine />
      <SectionWrapper paddingSm="30px 20px" paddingXl="40px 100px">
        <TitleSocialWrapper>
          <TitleWrapper>
            <SectionTitle>Contact</SectionTitle>
          </TitleWrapper>
          <SocialWrapper>
            {socials.map((item, index) => {
              return item.url ? (
                <a
                  key={index}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={item.icon} alt={item.url} />
                </a>
              ) : null
            })}
          </SocialWrapper>
        </TitleSocialWrapper>
        <MoverInfoWrapper>
          {phone && (
            <MoverInfoItem href={`tel:${phone}`}>
              <img src={dot} alt="dot" />
              <span>{phone}</span>
            </MoverInfoItem>
          )}
          {website && (
            <MoverInfoItem
              href={website}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={dot} alt="dot" />
              <span>Website</span>
            </MoverInfoItem>
          )}
          {google_page_url && (
            <MoverInfoItem
              href={google_page_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={dot} alt="dot" />
              <span>Google map</span>
            </MoverInfoItem>
          )}
        </MoverInfoWrapper>
        <Map lat={lat} lon={lon} />
      </SectionWrapper>
    </Wrapper>
  )
}

export default ContactSection

const Wrapper = styled.div``

const TitleSocialWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 30px;
  @media screen and (min-width: ${breakpoint.xl}) {
    flex-direction: row;
    margin-bottom: 0;
  }
`

const TitleWrapper = styled.div`
  width: 100%;

  @media screen and (min-width: ${breakpoint.xl}) {
    width: 75%;
  }
`

const SocialWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  justify-content: flex-start;
  a {
    color: ${color.gray};
    transition: ${transition.default};

    &:hover {
      opacity: ${opacity.default};
    }
  }
`

const MoverInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  row-gap: 20px;
  margin-bottom: 30px;
  a {
    color: ${color.gray};
    font-weight: 300;
    transition: ${transition.default};

    &:hover {
      color: ${color.link};
    }
  }
`

const MoverInfoItem = styled.a`
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;

  @media screen and (min-width: ${breakpoint.xl}) {
    column-gap: 20px;
  }
`
